import React from 'react';
import { Link } from "react-router-dom";
import Navbar from "../inc/Navbar";
import fb from "../images/fb2.jpg";

import Linkdin from "../images/linkdin.jpg";
import Instagram from "../images/insta.jpg";
import ScrollToTop from "react-scroll-to-top"
import { Typewriter } from 'react-simple-typewriter'
import tanmaysarkar from "../images/mr.indian coder.jpg";

import Angularjs from "../images/angularjs.jpg"
import css from "../images/css.jpg";
import Firebase from "../images/firebase.jpg";
import Html from "../images/html.jpg";
import Nodejs from "../images/nodejs.jpg";
import Pythan from "../images/pythan.jpg";
import Reactjs from "../images/react.jpg"
import Js from "../images/javasripts.jpg";
import Flutter from "../images/flutter.jpg";
import Yourube from "../images/youtube-logo.jpg";


import mak from "../images/Mountaineers’ Association of Krishnanagar.jpg";




// import Fileupload from "../pages/Fileupload";
import Rupaecobrick from "../images/rupaecbrick-debopriya gope.jpg"

import Studentpage from "../pages/Studentpage";
// import Uploadfile from "../pages/Uploadfile";
import Develop from "../pages/Develop";
import {
    FacebookShareButton, WhatsappShareButton, WhatsappIcon,
    FacebookIcon, TwitterShareButton, EmailShareButton, EmailIcon,
    LinkedinShareButton,
    LinkedinIcon,
    TwitterIcon,
} from "react-share";


import './Home.css'
import AddBook from "../AddBook";
import Reviews from './Reviews';
import Sliderinvite from './Sliderinvite';
import Slidermisaa from './Slidermisaa';


function Home() {
    return (
        <>
            <Navbar />
            <br />
            <br />
            <br />
            <br />


            <div className="album py-2">
                <div className="container">

                    <div className="row">
                        <div className="col-md-6 mt-3">
                            <div className='backradius'>
                                <img src={tanmaysarkar} className="d-block w-100 mb-2" alt="bestwebsitedevelopmentinnadia" />
                            </div>

                            <div className="album py-0">
                                <div className="container">
                                    <h1 className='mb-0' style={{ color: "grey" }}><b> G.P. PREMIA SHOWROOM</b>  GRAND OPENING INVITED </h1>
                                    <h5 style={{ color: "#A57040" }}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16">
                                        <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                                        <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                    </svg> NH-12, BHATJANGLA, KRISHNAGAR</h5>
                                </div>
                            </div>

                            <Sliderinvite />
                        </div>
                        <div className="col-md-6 mt-3">
                            <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fmrindiancoder&tabs=timeline&width=500&height=700&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" width="100%" height="630" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>

                        </div>
                    </div>

                </div>
            </div>
            <ScrollToTop smooth top="100" color="Gray" />

            <div className="p-2 mb-0 bg-light text-dark">


                <div className="album py-1">

                    <div className="container">

                        <div className="row">

                            <div className="col-md-6 mt-4 me-0" >

                                <div className="radiustanmaycoder">
                                    <div className='hoverimagecoder'>
                                        <img src={Rupaecobrick} className="card-img-top image5" alt="Rupaecobrick" />
                                        <div className="bestwebsitedeveloperwestbengal ">MR. INDIAN CODER</div>
                                    </div>
                                </div>
                                <div className="d-flex justify-content-between align-items-center">
                                </div>

                            </div>
                            <div className="col-md-6 mt-4" >
                                <h2 style={{ textAlign: "center", color: "Gray" }}> <b>MR. INDIAN CODER</b> with RUPA ECO BRICK OWNER Debapriya Gope</h2>
                                <p style={{ textAlign: "center", color: "Darkblue" }} > Our Develop Website : <Link to="/our-development" className="btn btn-light" target="_blank"
                                    rel="noopener noreferrer">
                                    CLICK HERE
                                </Link>
                                </p>
                                <br />
                                <p >Our Development Website Live - Berhampore-Murshidabad, Kolkata,  Karimpur, Krishnanagar-Nadia, Purba Bardhaman (West Bengal) | India's Famous & Trusted Website Developer </p>
                                <p>Feel free to get in touch with me today to discuss your project.</p>
                                <br />
                                <h5 className='mb-3'>Contact Information:</h5>
                                <div className="d-flex justify-content-between align-items-center">
                                    <a href="tel: +91 9933798896" className="buttonnav mb-2">
                                        <div className='' style={{ color: "white" }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward" viewBox="0 0 16 16">
                                                <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
                                            </svg> +91 9933798896*

                                        </div>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <Develop />

                <div className="album py-0">
                    <div className="container">
                        <h1 style={{ color: "grey" }}> REVIEWS</h1>
                    </div>
                </div>
                <Reviews />




            </div>



            <div style={{
                backgroundImage: "url(" + "https://i.postimg.cc/QMQRXsH4/txmrM7.jpg" + ")",
                backgroundPosition: 'center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat'
            }}>
                <br />
                <br />
                <center>
                    <Link to="/coding" className="buttoncoding button2">CODING COURSE LAUNCH <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-code-slash" viewBox="0 0 16 16">
                        <path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294l4-13zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0zm6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0z" />
                    </svg> <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                        </svg></Link></center>
                <div className="album py-1">

                    <div className="container">

                        <div className="row">
                            <center>
                                <h1 style={{ fontSize: "2rem", color: "Gray" }} className="card-text mb-4"> <b>MR. INDIAN CODER </b> ACADEMY</h1>
                            </center>
                            <h1 style={{ color: "Darkblue", fontSize: "3rem" }} className="card-text"> <b>INDIA'S FAMOUS WEBSITE DEVELOPER</b></h1>

                        </div>
                    </div>
                </div>
                <br />
                <br />
                <br />




                <div className="album py-2">

                    <div className="container">

                        <div className="row">


                            < p className="card-text " style={{ margin: "auto 0", color: "dark" }}> <b> Expert In :  <span style={{ fontWeight: "bold", marginleft: '10px', color: "Darkblue" }}>
                                <Typewriter
                                    loop
                                    cursor
                                    cursorStyle="_"
                                    typeSpeed={100}
                                    deleteSpeed={50}
                                    delaySpeed={1000}
                                    words={["Website Development", "Web Design", "Photoshop", "Backend Software", "React Js Website Development", "Android & IOS App"]}
                                />
                            </span>
                            </b></p>
                        </div>
                    </div>
                </div>
                <br />
                <br />


                <br />


                <div className="album py-2">

                    <div className="container">

                        <div className="row">
                            <div className="indiastrustedwebsitedevelopment">
                                <h1 style={{ fontSize: "4rem" }} className="card-text mb-8"> <b>MR. INDIAN CODER</b></h1>
                            </div>
                        </div>
                    </div>
                </div>
                <br />



            </div>

            {/* <img src={ MRINDIANCODER} class="img-fluid" width="1350" height="1000"  alt=" MR. INDIAN CODER"></img> */}
            {/* <Uploadfile/>
<br/>
<Fileupload/> */}

            {/* <Sliders/> */}
            <div className="backgroundc">

                <div className="album py-0">

                    <div className="container">

                        <div className="row">
                            <div className="col-md-7">

                                <div className="card-body">

                                    <h1 className="card-text mb-2" style={{ paddingTop: "1rem", margin: "auto 0", color: "Gray" }}> <b>  <span style={{ color: "white", fontWeight: "bold", marginleft: '7px' }}>
                                        <Typewriter
                                            loop
                                            cursor
                                            cursorStyle="_"
                                            typeSpeed={90}
                                            deleteSpeed={50}
                                            delaySpeed={1000}
                                            words={[" HEALTHCARE WEBSITE", " EDUCATION WEBSITE", "GOVT. WEBSITE", "SINGER WEBSITE", "BUSINESS WEBSITE", "VLOG WEBSITE", "PERSONAL BRAND WEBSITE", "CORPORATE WEBSITE", "PHOTOGRAPHER WEBSITE"]}
                                        />
                                    </span>
                                    </b></h1>

                                    <p className="mrindiancoderlive mb-2">The website of your dreams will be improved and faster</p>

                                </div>


                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="p-0 mb-0 bg-secondary text-light">
                <div className="album py-2">

                    <div className="container">

                        <div className="row">
                            <h1> Best React JS Website Development Company in West Bengal</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div className="album py-4">

                <div className="container">

                    <div className="row">

                        <div className="col-md-4 mt-8" >
                            <div className="card mb-4 border-White box">
                                <Link to="/Singer" target='_blank'>

                                </Link>
                                <div className="card-body">

                                    <h6 className="card-text"> <b>Singer World Wide Website</b></h6>
                                    <p className="card-text">Even after doing web pages, we are on the 24X7 side</p>

                                    <button type="button" className="btn btn btn-dark me-2">
                                        Share <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-share-fill" viewBox="0 0 16 16">
                                            <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />
                                        </svg>
                                    </button>

                                    < FacebookShareButton url="https://www.mrindiancoder.com/Singer" className="me-2" quote={"India's Most Iconic Website Developer"} hastag={"#WebApp"}
                                    >
                                        <FacebookIcon size={37} round={true} />
                                    </FacebookShareButton>

                                    <  WhatsappShareButton url="https://www.mrindiancoder.com/Singer" className="me-2" quote={"India's Most Iconic Website Developer"} hastag={"#WebApp"}
                                    >
                                        <WhatsappIcon size={37} round={true} />
                                    </ WhatsappShareButton>

                                    < TwitterShareButton url="https://www.mrindiancoder.com/Singer" className="me-2" quote={"India's Most Iconic Website Developer"} hastag={"#WebApp"}
                                    >
                                        <TwitterIcon size={37} round={true} />
                                    </TwitterShareButton>
                                    <  LinkedinShareButton url="https://www.mrindiancoder.com/Singer" className="me-2" quote={"India's Most Iconic Website Developer"} hastag={"#WebApp"}
                                    >
                                        <  LinkedinIcon size={37} round={true} />
                                    </ LinkedinShareButton>

                                    <  EmailShareButton url="https://www.mrindiancoder.com/Singer" className="me-2" quote={"India's Most Iconic Website Developer"} hastag={"#WebApp"}
                                    >
                                        <  EmailIcon size={37} round={true} />
                                    </ EmailShareButton>
                                    <div className="d-flex justify-content-between align-items-center">

                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-4 mt-6" >
                            <div className="card mb-4 border-White box">
                                <Link to="/Gov" target='_blank'>

                                </Link>
                                <div className="card-body">
                                    <h6 className="card-text"><b>Government School Website</b></h6>
                                    <p className="card-text">
                                        Clicking on the content of your website will open the page within 1 second.</p>
                                    <button type="button" className="btn btn btn-dark me-2">
                                        Share  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-share-fill" viewBox="0 0 16 16">
                                            <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />
                                        </svg>
                                    </button>
                                    < FacebookShareButton url="https://www.mrindiancoder.com/Gov" className="me-2" quote={"India's Most Iconic Website Developer"} hastag={"#WebApp"}
                                    >
                                        <FacebookIcon size={37} round={true} />
                                    </FacebookShareButton>

                                    <  WhatsappShareButton url="https://www.mrindiancoder.com/Gov" className="me-2" quote={"India's Most Iconic Website Developer"} hastag={"#WebApp"}
                                    >
                                        <WhatsappIcon size={37} round={true} />
                                    </ WhatsappShareButton>

                                    < TwitterShareButton url="https://www.mrindiancoder.com/Gov" className="me-2" quote={"India's Most Iconic Website Developer"} hastag={"#WebApp"}
                                    >
                                        <TwitterIcon size={37} round={true} />
                                    </TwitterShareButton>
                                    <  LinkedinShareButton url="https://www.mrindiancoder.com/Gov" className="me-2" quote={"India's Most Iconic Website Developer"} hastag={"#WebApp"}
                                    >
                                        <  LinkedinIcon size={37} round={true} />
                                    </ LinkedinShareButton>

                                    <  EmailShareButton url="https://www.mrindiancoder.com/Gov" className="me-2" quote={"India's Most Iconic Website Developer"} hastag={"#WebApp"}
                                    >
                                        <  EmailIcon size={37} round={true} />
                                    </ EmailShareButton>
                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>
                        {/* style={{textAlign: "center"}} */}
                        <div className="col-md-4" >
                            <div className="card mb-4 border-White box">
                                <Link to="/Jewellers" target='_blank'>
                                    {/* <img src={Jewellersweb} className="card-img-top"   alt="jewellerswebsite" /> */}
                                </Link>
                                <div className="card-body">
                                    <h6 className="card-text"><b>Jewellers & Dimond Website</b></h6>
                                    <p className="card-text"> The fastest website builder</p>

                                    <button type="button" className="btn btn btn-dark me-2">
                                        Share <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-share-fill" viewBox="0 0 16 16">
                                            <path d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z" />
                                        </svg>
                                    </button>

                                    < FacebookShareButton url="https://www.mrindiancoder.com/Jewellers" className="me-2" quote={"India's Most Iconic Website Developer"} hastag={"#WebApp"}
                                    >
                                        <FacebookIcon size={37} round={true} />
                                    </FacebookShareButton>

                                    <  WhatsappShareButton url="https://www.mrindiancoder.com/Jewellers" className="me-2" quote={"India's Most Iconic Website Developer"} hastag={"#WebApp"}
                                    >
                                        <WhatsappIcon size={37} round={true} />
                                    </ WhatsappShareButton>

                                    < TwitterShareButton url="https://www.mrindiancoder.com/Jewellers" className="me-2" quote={"India's Most Iconic Website Developer"} hastag={"#WebApp"}
                                    >
                                        <TwitterIcon size={37} round={true} />
                                    </TwitterShareButton>
                                    <  LinkedinShareButton url="https://www.mrindiancoder.com/Jewellers" className="me-2" quote={"India's Most Iconic Website Developer"} hastag={"#WebApp"}
                                    >
                                        <  LinkedinIcon size={37} round={true} />
                                    </ LinkedinShareButton>

                                    <  EmailShareButton url="https://www.mrindiancoder.com/Jewellers" className="me-2" quote={"India's Most Iconic Website Developer"} hastag={"#WebApp"}
                                    >
                                        <  EmailIcon size={37} round={true} />
                                    </ EmailShareButton>
                                    <div className="d-flex justify-content-between align-items-center">




                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

<div className='misaa'>
    <br/>
            <div className="album py-1">
                <div className="container">
                    <h1 className='mb-0' style={{ color: "grey" }}><b> M.I.S.A.A </b>  ANNUAL RE-UNION 2024 INVITED </h1>
                      <p><a className='mb-0' href='https://www.misaa.org.in/' target="_blank" rel="noopener noreferrer">https://www.misaa.org.in/</a></p>
                </div>
            </div>

            <Slidermisaa />
         
                <br />
                <a href='our-development'>
                    <h2 style={{ textAlign: "center" }} className="card-text">  <div className="buttoncoding button2" > Our Best Work - CLICK NOW  </div></h2>
                </a>
                <br />
            
   </div>
            <center>
                <h1 className="mb-2" style={{ paddingTop: "2rem", margin: "auto 0", color: "Gray" }}> <b> Our  <span style={{ color: "Gray", fontWeight: "bold", marginleft: '10px' }}>
                    <Typewriter
                        loop
                        cursor
                        cursorStyle="_"
                        typeSpeed={90}
                        deleteSpeed={50}
                        delaySpeed={1000}
                        words={["Servies", " Services"]}
                    />
                </span>
                </b></h1>
                <p className="mb-5" >WE PROVIDE BEST SERVICES & SOLUTIONS</p>
            </center>


            <div className="mrindiancoder_global">

                <div className="album py-4">

                    <div className="container">

                        <div className="row">
                            <div className="col-md-4">
                                <div className="card mb-4 border-white box ">

                                    <div class="card text-center">
                                        <div class="card-body">
                                            <h5 class="card-title">Payment Gateway</h5>
                                            <p class="card-text">Affordable web design services in India, includes payment gateway for easy online transfer from any customer (debit/ credit…etc) account to your account for any sales website does.</p>
                                            <br />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center">
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card mb-4 border-white box ">
                                    <div class="card text-center">
                                        <div class="card-body">
                                            <h5 class="card-title">Web Development</h5>
                                            <p class="card-text">We develop website on highly optimized codes. We have in expertise team of developers with the expertise on the demanding technologies, frameworks, tools.</p>
                                            <br /><br />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center">
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="card mb-4 border-white box ">

                                    <div class="card text-center">
                                        <div class="card-body">
                                            <h5 class="card-title">Responsive Design</h5>
                                            <p class="card-text">Get your device responsive website to reach your potential audience across all the devices. We have expertise in trending technologies, frameworks, tools for to make website Fully mobile responsive.</p>
                                            <br />
                                        </div>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <img src={HealthD} className="card-img-top" alt="HealthD"/> */}
            </div>
            <div className='krishnagarwebsitedevelper'>
                <br/>
                <div className="album py-0">
                    <div className="container">
                        <h1 className='mb-0' style={{ color: "grey" }}><b> MAK (Mountaineers’ Association of Krishnanagar)</b>  GET-TOGETHER 2024 INVITED </h1>
                        <p><a className='mb-0' href='https://www.mak.org.in/' target="_blank" rel="noopener noreferrer">https://www.mak.org.in/</a></p>
                    </div>
                </div>
                <div className="album py-1">
                    <div className="container">
                        <div className='mak_krishnagar'>
                            <img src={mak} className="d-block w-100" alt="Mountaineers’ Association of Krishnanagar" />
                        </div>
                    </div>
                </div>
                <br/>
            </div>

            <center>
                <h1 className="mb-1" style={{ paddingTop: "2rem", margin: "auto 0", color: "Deepblack" }}> <b> Become a Website Development  <span style={{ color: "Gray", fontWeight: "bold", marginleft: '10px' }}>
                    <Typewriter
                        loop
                        cursor
                        cursorStyle="_"
                        typeSpeed={90}
                        deleteSpeed={50}
                        delaySpeed={1000}
                        words={["Marchent", " Tycoon"]}
                    />
                </span>
                </b></h1>
                <br />
                <div className="choos">
                    <h1 style={{ color: "Gray", }} className=" mb-4" >Why Choose Us?</h1>
                </div>
            </center>
            <div className="album py-2">

                <div className="container">

                    <div className="row">

                        <div className="col-md-6 mt-6" >


                            <h5 style={{ color: "Gray" }} className="card-text texts mb-3">The Vision of MR. INDIAN CODER is  to deliver our unique website
                                developemnt blend and value to each corner of the  world.</h5>


                            <h5 className='texts' style={{ color: "Gray" }}  > Distributor partners of MR. INDIAN CODER are enjoying <b>huge margins </b> and impeccable growth every year. It's easy to get started with tested, tried and high_ROI driven business models. Now currently the demand
                                for creating websites in 2022 is increasing. The industry has <b>huge growth </b>potential.</h5>
                            <br />
                            <br />
                            <Link to="/distributor" target='_blank'>
                                <button type="buttonbookfranchise" className="buttonbookfranchise mb-3">
                                    <b className='mb-1'> Book Distributor</b>
                                </button>
                            </Link>
                            <div className="d-flex justify-content-between align-items-center">


                            </div>

                        </div>
                        <div className="col-md-6 mt-6" >

                            <Develop />



                            <div className="d-flex justify-content-between align-items-center">

                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <br />
            <div class="p-2 mb-2 bg-light text-dark">
                <div className="album py-4">
                    
                <div className="container">

                    <div className="skill">
                        <h1 className=" skill mb-2"><center> <b>Our Skill</b></center></h1>
                    </div>

                    <p className="card-text"><center>We are always updated for the progress of your business.</center></p>

</div>
                </div>

            </div>
            <div className="album py-4">

                <div className="container">

                    <div className="row">

                        <div className="col-md-4 mt-3" >
                             
                            <div className="card mb-4 border-White shadow">
                                <img src={Reactjs} className="card-img-top" alt="Reactjsdevelopernadia,westbengal" />
                                <div className="card-body">

                                    <h6 className="card-text texts"> <b><center>React – A JavaScript library for building user interfaces</center></b></h6>
                                    <p className="card-text texts"><small> 74.5% of developers recommend to use reactjs, it is one of the most loved frameworks. There are so many tools that help in web and app development but among all only a few are preferred by the enterprises. Facebook's ReactJS is one of them. </small> </p>
                                    <div className="d-flex justify-content-between align-items-center">



                                    </div>
                                </div>
                            </div>
                            

                        </div>
                        <div className="col-md-4 mt-3" >
                            <div className="card mb-4 border-white box shadow">
                                <img src={Nodejs} className="card-img-top" alt="Nodejsdeveloperinwestbengal" />
                                <div className="card-body">
                                    <h6 className="card-text texts"><b> Node.js® is a JavaScript runtime built on Chrome's V8 JavaScript engine. </b></h6>
                                    <p className="card-text">Node.js is an open-source, cross-platform, back-end JavaScript runtime environment that runs on the V8 engine and executes JavaScript code outside a web browser. </p>
                                    <br />
                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="col-md-4 mt-3" >
                            <div className="card mb-4 border-white box shadow">
                                <img src={Pythan} className="card-img-top" alt="Pythan" />
                                <div className="card-body">
                                    <h6 className="card-text"> <b> Python is a High-level programming language</b></h6>
                                    <p className="card-text texts"> What is Python used for? Python is a computer programming language often used to build websites and software, automate tasks, and conduct data analysis.</p>
                                    <br />
                                    <div className="d-flex justify-content-between align-items-center">



                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card mb-4 border-white box shadow">
                                <img src={Html} className="card-img-top" alt="Html-css-developerinwestbengal,nadia" />
                                <div className="card-body">
                                    <h6 className="card-text"><b><center>The HyperText Markup Language, HTML(Programming language)</center></b></h6>
                                    <p className="card-text texts"> The HyperText Markup Language or HTML is the standard markup language for documents designed to be displayed in a web browser. It can be assisted by technologies such as Cascading Style Sheets and scripting languages such as JavaScript. </p>
                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card mb-4 border-white box shadow">
                                <img src={css} className="card-img-top" alt="bestjewellerswebsitedevelopmentinwestbengal" />
                                <div className="card-body">
                                    <h6 className="card-text"><b><center>Cascading Style Sheets is a style sheet language</center></b></h6>
                                    <p className="card-text texts">  Cascading Style Sheets is a style sheet language used for describing the presentation of a document written in a markup language such as HTML. CSS is a cornerstone technology of the World Wide Web, alongside HTML and JavaScript. </p>
                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card mb-4 border-white box shadow">
                                <img src={Firebase} className="card-img-top" alt="Firebase" />
                                <div className="card-body">
                                    <h6 className="card-text"><b><center>Google Firebase is a Google-backed application development software </center></b></h6>
                                    <p className="card-text texts">  Firebase is a platform developed by Google for creating mobile and web applications. It was originally an independent company founded in 2011. In 2014, Google acquired the platform it is now their flagship offering for app development</p>
                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card mb-4 border-white box shadow">
                                <img src={Js} className="card-img-top" alt="Js" />
                                <div className="card-body">
                                    <h6 style={{ textAlign: "center" }} className="card-text"> <b>JavaScript is a Programming language</b></h6>
                                    <p className="card-text texts"> JavaScript, often abbreviated JS, is a programming language that is one of the core technologies of the World Wide Web, alongside HTML and CSS. Over 97% of websites use JavaScript on the client side for web page behavior, often incorporating third-party libraries. </p>

                                    <div className="d-flex justify-content-between align-items-center">



                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card mb-4 border-white box shadow">
                                <img src={Flutter} className="card-img-top" alt="Flutter" />
                                <div className="card-body">
                                    <h6 style={{ textAlign: "center" }} className="card-text"><b>Flutter - Build apps for any screen</b></h6>
                                    <p className="card-text texts">Flutter is an open-source UI software development kit created by Google. It is used to develop cross platform applications for Android, iOS, Linux, macOS, Windows, Google Fuchsia, and the web from a single codebase. First described in 2015, Flutter was released in May 2017. </p>

                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-4 mt-3">
                            <div className="card mb-4 border-white box shadow">
                                <img src={Angularjs} className="card-img-top" alt="reactjswebsitedeveloperinwb" />
                                <div className="card-body">
                                    <h6 className="card-text"><b><center>AngularJS is a JavaScript framework</center></b></h6>
                                    <p className="card-text texts"> AngularJS was a JavaScript-based open-source front-end web framework for developing single-page applications. It was maintained mainly by Google and a community of individuals and corporations. <br />
                                        Developer(s): Google
                                    </p>
                                    <br />
                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <br />

            {/* <Uploadfile/> */}
            {/* <Fileupload/> */}
            <Studentpage />
            <br />

            <br />
            <br />








            <center><h2 style={{ textAlign: "center", color: "Darkblue" }} ><b>Follow Me</b></h2></center>
            <div className="album py-4">

                <div className="container">

                    <div className="row">

                        <div className="col-md-3 mt-3" >

                            <div className="card mb-4 border-white box  ">
                                <a href="https://www.facebook.com/profile.php?id=100084747566591"
                                    target="_blank"
                                    rel="noopener noreferrer" >

                                    <img src={fb} className="card-img-top" alt="fb" />
                                </a>
                                <div className="card-body">
                                    <center>
                                        <h6 className="card-text"><b style={{ textAlign: "center", color: "Gray" }}>Like, Share & Comment</b></h6>
                                    </center>
                                    <div className="d-flex justify-content-between align-items-center">

                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* style={{textAlign: "center"}} */}
                        <div className="col-md-3 mt-3">
                            <div className="card mb-4 border-white box ">
                                <a href="https://www.linkedin.com/company/mr-indian-coder/"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    <img src={Linkdin} className="card-img-top" alt="Linkdin" /></a>
                                <div className="card-body">
                                    <center>
                                        <h6 className="card-text"><b style={{ textAlign: "center", color: "Gray" }}>Like, Share & Comment</b></h6>
                                    </center>




                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-3 mt-3" >
                            <div className="card mb-4 border-white box ">
                                <a href="https://www.instagram.com/mrindiancoder/"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    <img src={Instagram} className="card-img-top" alt="Instagram" /></a>
                                <div className="card-body">
                                    <center>
                                        <h6 className="card-text"><b style={{ textAlign: "center", color: "Gray" }}> Like, Share & Comment</b></h6>
                                    </center>

                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-md-3 mt-3">
                            <div className="card mb-4 border-white box ">
                                <a href="https://www.youtube.com/@MR.INDIAN-CODER/"
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    <img src={Yourube} className="card-img-top" alt="Yourube" /></a>
                                <div className="card-body">
                                    <center>
                                        <h6 className="card-text"><b style={{ textAlign: "center", color: "Gray" }}> Like, Share & Comment</b></h6>
                                    </center>

                                    <div className="d-flex justify-content-between align-items-center">


                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
            <AddBook />
            <br />


        </>

    );
}

export default Home;